"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAppSetTransitionSideMenuAction = exports.buildAppSetIsSideMenuOpenedAction = exports.buildAppSetIsBottomMenuOpenedAction = exports.buildAppUpdateConfirmAlertContextAction = exports.buildAppUpdateAlertContextAction = exports.buildAppUpdateInputdialogContextAction = exports.buildAppOpenImageViewer = exports.buildAppUpdateAdmobInterstitialContextAction = exports.buildAppUpdateRunningModeAction = exports.buildAppSetCustomFontNameAction = exports.buildAppResetAction = void 0;
const applicationStateConstants_1 = __importDefault(require("../shared/applicationStateConstants"));
const buildAppResetAction = () => ({ type: applicationStateConstants_1.default.RESET });
exports.buildAppResetAction = buildAppResetAction;
const buildAppSetCustomFontNameAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_CUSTOM_FONT_NAME,
    payload,
});
exports.buildAppSetCustomFontNameAction = buildAppSetCustomFontNameAction;
const buildAppUpdateRunningModeAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_RUNNING_MODE,
    payload,
});
exports.buildAppUpdateRunningModeAction = buildAppUpdateRunningModeAction;
const buildAppUpdateAdmobInterstitialContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_ADMOB_INTERSTITIAL_CONTEXT,
    payload,
});
exports.buildAppUpdateAdmobInterstitialContextAction = buildAppUpdateAdmobInterstitialContextAction;
const buildAppOpenImageViewer = (payload) => ({
    type: applicationStateConstants_1.default.OPEN_IMAGE_VIEWER,
    payload,
});
exports.buildAppOpenImageViewer = buildAppOpenImageViewer;
const buildAppUpdateInputdialogContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_INPUTDIALOG_CONTEXT,
    payload,
});
exports.buildAppUpdateInputdialogContextAction = buildAppUpdateInputdialogContextAction;
const buildAppUpdateAlertContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_ALERT_CONTEXT,
    payload,
});
exports.buildAppUpdateAlertContextAction = buildAppUpdateAlertContextAction;
const buildAppUpdateConfirmAlertContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_CONFIRM_ALERT_CONTEXT,
    payload,
});
exports.buildAppUpdateConfirmAlertContextAction = buildAppUpdateConfirmAlertContextAction;
const buildAppSetIsBottomMenuOpenedAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_IS_BOTTOM_MENU_OPENED,
    payload,
});
exports.buildAppSetIsBottomMenuOpenedAction = buildAppSetIsBottomMenuOpenedAction;
const buildAppSetIsSideMenuOpenedAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_IS_SIDE_MENU_OPENED,
    payload,
});
exports.buildAppSetIsSideMenuOpenedAction = buildAppSetIsSideMenuOpenedAction;
const buildAppSetTransitionSideMenuAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_TRANSITION_SIDE_MENU,
    payload,
});
exports.buildAppSetTransitionSideMenuAction = buildAppSetTransitionSideMenuAction;
